module.exports = __webpack_public_path__ + "static/media/14UNEP6.e1254b7f.jpg";